'use client';
import type { CSSProperties, ReactElement } from 'react';
import { CherobackgroundPrismLayer } from './CherobackgroundPrismLayer';
import type { CherobackgroundControllerState } from './useCherobackgroundController';
interface CherobackgroundRootProps extends CherobackgroundControllerState {
    className?: string;
    style?: CSSProperties;
}
export function CherobackgroundRoot({ backgroundMode, className, glow, handlePrismError, handlePrismFpsSample, isMobile, prismConfig, scale, style, }: CherobackgroundRootProps): ReactElement {
    const wrapperStyle: CSSProperties = {
        position: 'fixed',
        left: 0,
        top: isMobile ? '30px' : 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 0,
        ...style,
    };
    return <div data-el="Cherobackground/Root" style={wrapperStyle} className={className}>
            <CherobackgroundPrismLayer backgroundMode={backgroundMode} glow={glow} onPrismError={handlePrismError} onPrismFpsSample={handlePrismFpsSample} prismConfig={prismConfig} scale={scale}/>
        </div>
        ;
}
